//
//
//
//
//
//

export default {
  name: 'CButton',
  props: {
    type: {
      required: false,
      default: 'primary',
      type: String
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CButton/CButton.vue